import * as S from './styles'

const Header = () => {
  return (
    <S.Wrapper>
      <h1>What Is My Screen Resolution?</h1>
    </S.Wrapper>
  )
}

export default Header
